import { render, staticRenderFns } from "./PolicyActivateModal.vue?vue&type=template&id=2dd65ee7&scoped=true"
import script from "./PolicyActivateModal.vue?vue&type=script&lang=js"
export * from "./PolicyActivateModal.vue?vue&type=script&lang=js"
import style0 from "./PolicyActivateModal.vue?vue&type=style&index=0&id=2dd65ee7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd65ee7",
  null
  
)

export default component.exports